import { render, staticRenderFns } from "./InscripcionMundoDeportivo.vue?vue&type=template&id=74c39294"
import script from "./InscripcionMundoDeportivo.vue?vue&type=script&lang=js"
export * from "./InscripcionMundoDeportivo.vue?vue&type=script&lang=js"
import style0 from "./InscripcionMundoDeportivo.vue?vue&type=style&index=0&id=74c39294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports